type AuthRecoveryHandlers = {
  refreshAccessToken: () => Promise<string>;
  onUnauthorized: () => void;
};

let accessToken: string | null = null;
let recoveryHandlers: AuthRecoveryHandlers | null = null;
let refreshPromise: Promise<string> | null = null;

const readStoredAccessToken = (): string | null => {
  try {
    return typeof window === "undefined"
      ? null
      : window.sessionStorage.getItem("access_token");
  } catch {
    return null;
  }
};

const writeStoredAccessToken = (token: string | null): void => {
  try {
    if (typeof window === "undefined") return;
    if (token) window.sessionStorage.setItem("access_token", token);
    else window.sessionStorage.removeItem("access_token");
  } catch {
    // Keep the in-memory session usable if browser storage is unavailable.
  }
};

export const getAccessToken = (): string | null =>
  accessToken ?? (accessToken = readStoredAccessToken());

export const setAccessToken = (token: string): void => {
  accessToken = token;
  writeStoredAccessToken(token);
};

export const clearAccessToken = (): void => {
  accessToken = null;
  writeStoredAccessToken(null);
};

export const configureAuthRecovery = (
  handlers: AuthRecoveryHandlers,
): (() => void) => {
  recoveryHandlers = handlers;
  return () => {
    if (recoveryHandlers === handlers) recoveryHandlers = null;
  };
};

export const recoverAccessToken = async (): Promise<string | null> => {
  if (!recoveryHandlers) return null;

  if (!refreshPromise) {
    refreshPromise = recoveryHandlers.refreshAccessToken().finally(() => {
      refreshPromise = null;
    });
  }
  return refreshPromise;
};

export const notifyUnauthorized = (): void => {
  clearAccessToken();
  recoveryHandlers?.onUnauthorized();
};
